import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TSegmentsReqParams,
  TSegmentsResponse,
} from '../types/segments.types';

export const getSegmentsService = async (
  counterpartyGUID: string,
  params?: TSegmentsReqParams,
): Promise<TSegmentsResponse> => {
  const url = API_ENDPOINTS.SEGMENTS.COUNTERPARTY_SEGMENTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TSegmentsResponse>(url, config);

  return res.data;
};
